import { isGroupChatAccessRefused } from '../chat/group-chat-backend';

/** Core or Reach refused the person (401, 403, 404): what they last saw is no longer theirs to see. */
export function isAccessRefused(error: unknown): boolean {
  if (typeof error === 'object' && error !== null && 'status' in error && error.status === 401) {
    return true;
  }
  return isGroupChatAccessRefused(error);
}

/** Loaded data worth showing: a failed refresh keeps it unless the failure was a refusal. */
export function hasUsableData(query: { data?: unknown; error?: unknown }): boolean {
  return query.data !== undefined && !isAccessRefused(query.error);
}

/** The error to show among several sources: an access refusal outranks a transient failure. */
export function mostTellingError(...errors: (Error | null | undefined)[]): Error | null {
  return errors.find(isAccessRefused) ?? errors.find(Boolean) ?? null;
}
